/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/transaction */
import{hexToBin as r,sha256 as n,binToHex as s}from"/@bitauth/libauth@^3.1.0-next.8?target=esnext";async function e(a){let o=r(a);return s(n.hash(n.hash(o)).reverse())}export{e as getTransactionHash};
//# sourceMappingURL=transaction.mjs.map